import {useMutation} from '@tanstack/react-query';

import {apiClient} from '../../../../utils/api-client';
import {useDeleteQueryInCache, useRestoreQueryInCache} from '../cache-control-hooks';
import {showErrorNotification} from '../../../../providers/notifications-center/show-notification';

function restoreQueryRequest(queryId: number) {
    return apiClient.patch<unknown>({
        path: `queries-service/api/queries/${queryId}`,
        parameters: {trash: false}
    });
}

export function useRestoreQueryMutation() {
    const deleteQueryInCache = useDeleteQueryInCache();
    const restoreQueryInCache = useRestoreQueryInCache();

    return useMutation<unknown, Error, QueryInfo>({
        mutationFn: (query: QueryInfo) => {
            restoreQueryInCache(query);
            return restoreQueryRequest(query.id);
        },
        onError: (err, payload) => {
            deleteQueryInCache(payload);
            showErrorNotification()(err);
        }
    });
}
